export const getImage = (files) => {
  if (files && files.length > 0) {

    return process.env.REACT_APP_API_URL + files[0].path

  } else {

    return `images/tent-${Math.floor(Math.random() * 3) + 1}.png`
    
  }
}